<template>
  <v-card class="ma-5 mt-0">
    <div
      style="
        background-color: white !important;

        padding-left: 10px;
      "
    >
      <v-row class="pa-0" style="margin-top: 5px" justify="center">
        <v-col
          cols="12"
          md="12"
          xs="12"
          sm="12"
          class="pa-0 mt-0 font-weight-bold text-center"
          style="font-size: 22px; font-weight: 500"
        >
          Setup ACH Debit Service</v-col
        >
      </v-row>

      <v-row v-if="dd_info_empty == true">
        <v-radio-group v-model="$store.state.selectedOption" inline>
          <v-radio
            label="Keep Bank Account"
            value="1"
            style="color: black"
          ></v-radio>

          <v-radio
            label="Change Bank Account"
            value="2"
            style="color: black"
          ></v-radio>
        </v-radio-group>
      </v-row>

      <v-row justify="center" style="margin-top: 10px; padding-left: 10px">
        <v-card
          style="
            border: 1px solid black;
            padding: 20px;
            font-family: Arial, sans-serif;
          "
        >
          <v-row justify="center">
            <span style="font-size: 22px; font-weight: 500"
              >Your Bank Information</span
            >
          </v-row>
          <v-form ref="formsmain" lazy-validation>
            <v-row class="mt-5">
              <v-col cols="12" md="7" xs="12" sm="12">
                <v-text-field
                  v-model="accountNumber"
                  label="Account Number"
                  variant="outlined"
                  density="compact"
                  required
                  :rules="[validAccountNumber]"
                  style="max-width: 335px; height: 40px; margin-bottom: 30px"
                  class="custom-input"
                  @keypress="filter_digits_only()"
                  :disabled="$store.state.selectedOption === '1'"
                ></v-text-field>

                <v-text-field
                  v-model="abaNumber"
                  label="ABA Number"
                  variant="outlined"
                  density="compact"
                  required
                  :rules="[ValidAbaNumber]"
                  style="
                    max-width: 335px;
                    height: 40px;
                    margin-top: 10px;
                    margin-bottom: 30px;
                  "
                  class="custom-input"
                  @keypress="isNumberKey($event)"
                  :disabled="$store.state.selectedOption === '1'"
                ></v-text-field>

                <v-text-field
                  v-model="bankName"
                  label="Bank Name"
                  variant="outlined"
                  density="compact"
                  required
                  :rules="[validBankName]"
                  style="
                    max-width: 335px;
                    height: 40px;
                    margin-top: 10px;
                    margin-bottom: 20px;
                  "
                  class="custom-input"
                  :disabled="$store.state.selectedOption === '1'"
                ></v-text-field>

                <v-row
                  style="margin-top: 10px; margin-left: 0px"
                  class="font-weight-bold"
                  >Type of Account</v-row
                >
                <v-row
                  style="margin-top: 20px; margin-left: 0px"
                  cols="12"
                  xs="12"
                  sm="12"
                  md="12"
                >
                  <v-col cols="12" xs="12" sm="12" md="12">
                    <v-card class="d-flex justify-center align-center px-5">
                      <v-radio-group
                        v-model="$store.state.bank_account_type"
                        :rules="[namerules]"
                        inline
                        hide-details="auto"
                        :disabled="$store.state.selectedOption === '1'"
                        color="black"
                      >
                        <v-radio
                          v-for="option in backaccountOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.value"
                        ></v-radio>
                      </v-radio-group>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="5" xs="12" sm="12">
                <!-- <p style="font-weight: bold; margin: 0">
               Employee No : {{ $store.state.employee_number }}
              </p> -->
                <p style="font-weight: bold; margin: 0">
                  Name : {{ employee_name }}
                </p>
              </v-col>
            </v-row>

            <v-row class="my-5" align="start" no-gutters>
              <v-col cols="auto" class="d-flex align-center">
                <v-checkbox
                  label=" "
                  v-model="$store.state.checkbox"
                  :rules="[checkboxrules]"
                  style="margin-top: 5px; flex-shrink: 0"
                  color="black"
                ></v-checkbox>
              </v-col>

              <v-col
                cols="12"
                sm="10"
                md="11"
                style="border: solid 1px grey; padding: 5px; border-radius: 5px"
              >
                <p class="authtext">
                  I authorize {{ Master_Account_Name }} to use its third-party
                  vendor, Benefit Allocation Systems, LLC ("BAS"), to
                  automatically debit my account at the financial institution
                  listed above for payments related to benefits or services
                  provided by {{ Master_Account_Name }}. I understand that BAS
                  acts solely as a third-party processor on behalf of
                  {{ Master_Account_Name }}, and that this authorization applies
                  only to payments directed for {{ Master_Account_Name }}.
                </p>
                <p class="authtext">
                  I understand that payment amounts may change from time to time
                  due to plan elections, rate changes, coverage modifications,
                  or other plan-related adjustments. If my banking information
                  changes, I agree to submit a new authorization promptly. I
                  will furnish a copy of this authorization for each account
                  subject to ACH.
                </p>
                <p class="authtext">
                  If an ACH withdrawal is not honored for any reason, including
                  insufficient funds or account closure, I understand that
                  payment remains due and that BAS is not responsible for any
                  missed payments, penalties, interest, or loss of coverage
                  resulting from the failed transaction. I am responsible for
                  ensuring that sufficient funds are available for each ACH
                  withdrawal.
                </p>
                <p class="authtext" style="margin-top: 0px">
                  I agree that the origination of ACH debit transactions will
                  comply with the rules of the National Automated Clearing House
                  Association (“NACHA”) and applicable United States law. I
                  understand that I may request a copy of this authorization for
                  my records.
                </p>
                <p class="authtext">
                  I understand that I may revoke this authorization by providing
                  advance written notice in accordance with applicable
                  procedures and that revocation will apply only to future ACH
                  transactions after reasonable processing time.
                </p>
              </v-col>
            </v-row>
          </v-form>

          <!-- E-Signature -->
          <v-row class="pt-5">
            <v-col cols="12">
              <span style="font-size: 22px; font-weight: 500">E-Signature</span>

              <p>
                By entering your full name below, you acknowledge that this
                serves as your electronic signature, agreeing to the terms
                outlined in this form.
              </p>

              <div ref="sourceDiv" style="background: #fff">
                <input
                  id="sign"
                  v-model="sign_value"
                  style="
                    width: 100%;
                    max-width: 100%;
                    font-family: 'Brush Script MT';
                    font-size: 35px;
                    color: blue;
                    padding: 12px 10px;
                    border: 1px solid #000;
                    line-height: 2;
                    box-sizing: border-box;
                  "
                />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-row>

      <v-row>
        <div style="margin-top: 30px"></div>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      backaccountOptions: [
        { id: 1, label: "Checking", value: "0" },
        { id: 2, label: "Saving", value: "1" },
      ],
      First_Name: "",
      Middle_Name: "",
      Last_Name: "",
      Master_Account_Name: "",
      employee_name: "",
      Address1: "",
      Address2: "",
      City: "",
      State: "",
      Zip_Code: "",
      premiumData: [],

      errorDialog: false,
      checkbox: false,
      errorMessages: [],
      appurl: "",
      bank_branch: "",
      dd_info: [],
      skipPage: false,
      confirmDialog: false,
      dialogMessage: "",
      actionToConfirm: null,
      confirmDialogSubmit: false,
      isExpanded: true,
      effectiveDate: "",
      loading: false,
      skipPageCount: 0,
      emailDialogue: false,
      dd_info_empty: false,
      employee_number: "",
    };
  },
  mounted() {
    this.initializeData();
  },

  computed: {
    methodUrl() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },

    totalPremium() {
      return this.premiumData.reduce(
        (total, item) => total + item.MONTHLY_PREMIUM,
        0,
      );
    },
    //update store
    abaNumber: {
      get() {
        var self = this;
        return self.$store.state.abaNumber;
      },
      set(value) {
        var self = this;
        self.$store.state.abaNumber = value;
      },
    },

    accountNumber: {
      get() {
        var self = this;
        return self.$store.state.bank_account_number;
      },
      set(value) {
        var self = this;
        self.$store.state.bank_account_number = value;
      },
    },
    bankName: {
      get() {
        var self = this;
        return self.$store.state.bankName;
      },
      set(value) {
        var self = this;
        self.$store.state.bankName = value;
      },
    },
    bank_account_type: {
      get() {
        var self = this;
        return self.$store.state.bank_account_type;
      },
      set(value) {
        var self = this;
        self.$store.state.bank_account_type = value;
      },
    },
    sign_value: {
      get() {
        var self = this;
        return self.$store.state.sign_value;
      },
      set(value) {
        var self = this;
        self.$store.state.sign_value = value;
      },
    },
  },
  methods: {
    async initializeData() {
      try {
        this.employee_number = this.$store.state.employee_number;
        await this.Get_account_name();
        await this.get_ee_ach_data();
      } catch (error) {
        console.log("Error initializing data:", error);
      }
    },

    async Get_account_name() {
      var self = this;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/Get_account_name`,
          { employeeNumber: this.employee_number },
        )
        .then((r) => {
          const result = JSON.parse(r.data.d);

          if (result.length > 0) {
            self.$store.state.Master_Account_Name = result[0].ACCOUNT_NAME;
            self.Master_Account_Name = result[0].ACCOUNT_NAME;
            self.employee_name = result[0].EMPLOYEE_NAME;
          }
          return result;
        })
        .catch(function () {
          console.log("error -get_DDInfo");
        });
    },

    async get_ee_ach_data() {
      var self = this;
      axios
        .post(
          `${this.methodUrl}/make_payment/Webservice.asmx/get_ee_ach_data`,
          { employeeNumber: this.employee_number },
        )
        .then((r) => {
          const result = JSON.parse(r.data.d);
          self.dd_info = result;
          //console.log("dd" + JSON.stringify(self.dd_info));

          if (result.length > 0) {
            self.dd_info_empty = true;
            self.$store.state.selectedOption = "1";
            self.bankName = result[0].BANK_NAME;
            self.abaNumber = result[0].BANK_ABA_NUMBER;
            self.accountNumber = result[0].BANK_ACCOUNT_NUMBER_;

            self.bank_account_type = String(result[0].BANK_ACCOUNT_TYPE);

            self.$store.state.abaNumber = result[0].BANK_ABA_NUMBER;
            self.$store.state.bank_account_number =
              result[0].BANK_ACCOUNT_NUMBER_;
            self.$store.state.bankName = result[0].BANK_NAME;
            self.$store.state.bank_account_type = self.bank_account_type;
            self.$store.state.employee_number = result[0].EMPLOYEE_NUMBER;
            self.$store.state.employee_name = result[0].EMPLOYEE_NAME;
          } else {
            self.dd_info_empty = false;
            self.$store.state.selectedOption = "2";
          }
          return result;
        })
        .catch(function (e) {
          console.log("error -get_DDInfo" + e);
        });
    },

    filter_digits_only(evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (expect.length > 18) {
        evt.preventDefault();
      } else if (!/^[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberKey(event) {
      var keyCode = event.which || event.keyCode;
      if (keyCode >= 48 && keyCode <= 57) {
        return true;
      } else {
        event.preventDefault(); // Prevent the character from being entered
        return false;
      }
    },

    showDialog(action) {
      this.dialogMessage = `Are you sure you want to ${
        action === "cancel" ? "cancel" : "submit"
      }?`;
      this.confirmDialog = true;
    },
    // handleConfirm() {
    //   this.confirmDialog = false;
    //   this.cancel();
    // },

    // handleConfirmSubmit() {
    //   this.confirmDialogSubmit = false;
    //   this.submitACH();
    // },
    // submitACH() {
    //   this.insert_ach_record();
    //   this.emailDialogue = true;
    // },
    isvalid() {
      // console.log("Validating form...");
      this.$refs.formsmain.validate(); // Trigger validation for all fields
    },
    cancel() {
      this.accountNumber = "";
      this.abaNumber = "";
      this.bankName = "";
      this.bank_account_type = "";
      this.checkbox = "";
    },

    submit() {
      if (this.isvalid()) {
        this.confirmDialogSubmit = true;
      } else {
        this.errorDialog = true; // Open the static error dialog
      }
    },

    validAccountNumber(value) {
      const val = value ? String(value) : "";

      if (val === "") {
        return "Enter the Account Number";
      }
      //console.log("bank form dd_info_empty:", this.dd_info_empty);
      if (
        (this.dd_info_empty &&
          this.$store.state.selectedOption == "1" &&
          val.indexOf("*") > -1) ||
        val.indexOf("x") > -1
      ) {
        return true;
      }

      // // If there is no existing DD info, reject masked values
      // if (
      //   (!this.dd_info_empty && val.indexOf("x") > -1) ||
      //   val.indexOf("*") > -1
      // ) {
      //   return "Not a valid Account Number";
      // }

      // Require digits only (no spaces or other chars) and enforce reasonable length
      const digits = val.replace(/\s+/g, "");
      if (!/^[0-9]+$/.test(digits)) {
        return "Account number must contain only digits";
      }

      return true;
    },

    namerules(value) {
      if (value == "") {
        return "Select the type of account";
      } else {
        return true;
      }
    },
    ValidAbaNumber(value) {
      const val = value ? String(value).trim() : "";

      if (val === "") {
        return "Enter the ABA Number";
      }
      if (
        (this.dd_info_empty &&
          this.$store.state.selectedOption == "1" &&
          val.indexOf("*") > -1) ||
        (this.dd_info_empty &&
          this.$store.state.selectedOption == "1" &&
          val.indexOf("x") > -1)
      ) {
        return true;
      }

      // // If there is no existing DD info, reject masked values
      // if (
      //   (!this.dd_info_empty && val.indexOf("x") > -1) ||
      //   val.indexOf("*") > -1
      // ) {
      //   return "Not a Vaild Number";
      // }
      const digits = val.replace(/\s+/g, "");
      if (!/^[0-9]{9}$/.test(digits)) {
        return "Enter a valid 9-digit ABA number";
      }

      return true;
    },

    validBankName(value) {
      if (value == "") {
        return "Enter the Bank Name";
      } else {
        return true;
      }
    },
    checkboxrules(value) {
      if (value == "") {
        return "";
      } else {
        return true;
      }
    },
    formatDate(date) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const year = d.getFullYear();
      return `${month}/${day}/${year}`;
    },

    getbacnk_accounttype(value) {
      var result = "";
      switch (value) {
        case "Checking Account":
          result = "0";
          break;
        case "Saving Account":
          result = "1";
          break;
        case "Money Market":
          result = "2";
          break;
        default:
          result = ""; //no option will be selected
          break;
      }
      return result;
    },
  },
};
</script>

<style scoped>
.title-section {
  background-color: #e0e0e0;
  cursor: pointer;
  font-weight: bold;
  font-size: 18px;
}

.content-section {
  background-color: #ffffff;
}

.pdf-safe * {
  box-shadow: none !important;
  background-image: none !important;
  color: #000 !important;
  background-color: #fff !important;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  will-change: transform;
}
.inline-radios {
  display: flex !important;
  gap: 20px !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
}

.inline-radios .v-radio {
  display: inline-flex !important;
  white-space: nowrap !important;
}
.authtext {
  font-size: 14px;
  margin-left: 10px;
  margin-bottom: 0;
  margin-top: 5px;
  font-style: italic;
}
</style>
